module.exports = __webpack_public_path__ + "static/media/fill_59.5b891fa3.svg";